import { useMutation } from '@apollo/client';
import React from 'react';
import Select from 'react-select';

import { ReactComponent as ArrowDownIcon } from '../../../../assets/icons/arrow-down.svg';
import { useNotification } from '../../../../hooks/useNotification';
import { UPDATE_GREASE_TRAP } from '../../../../services/graphql/vendors/grease-traps/greaseTrapMutation';
import {
  colourStyles,
  CustomOption,
  CustomSingleValue,
} from '../../../../styles/statusDropdownStyle';

const GREASE_TRAP_STATUS_OPTIONS = [
  { value: 'In Review', label: 'IN REVIEW', color: '#4C80CD' },
  { value: 'Pending Payment', label: 'PENDING PAYMENT', color: '#FF932F' },
  { value: 'Paid', label: 'PAID', color: '#00870D' },
];

type Props = {
  greaseTrapId?: string;
  initialStatus: string;
  refetchSingleGreaseTrap: (id: string) => void;
  setLoading: (value: boolean) => void;
};

export const GreaseTrapStatusDropdown: React.FC<Props> = ({
  greaseTrapId,
  initialStatus,
  refetchSingleGreaseTrap,
  setLoading,
}) => {
  const { notifySaveError, notifySaveSuccess } = useNotification();
  const [status, setStatus] = React.useState(initialStatus);

  const [updateGreaseTrap] = useMutation(UPDATE_GREASE_TRAP, {
    onError: () => {
      notifySaveError();
      setLoading(false);
    },
    onCompleted: () => {
      if (greaseTrapId) {
        refetchSingleGreaseTrap(greaseTrapId);
      }
      notifySaveSuccess();
    },
  });

  const handleStatusChange = async (selectedOption: { value: string }) => {
    const newStatus = selectedOption.value;
    setLoading(true);

    await updateGreaseTrap({
      variables: {
        id: greaseTrapId,
        key: 'status',
        value: newStatus,
      },
    });

    setStatus(newStatus);
  };

  return (
    <div className="flex items-center justify-end gap-[15px]">
      <div className="flex items-center justify-center gap-1 rounded-md px-2.5">
        <Select
          styles={colourStyles(status, GREASE_TRAP_STATUS_OPTIONS)}
          components={{
            DropdownIndicator: () => <ArrowDownIcon />,
            IndicatorSeparator: () => null,
            Option: CustomOption,
            SingleValue: CustomSingleValue,
          }}
          options={GREASE_TRAP_STATUS_OPTIONS}
          onChange={(option) => {
            if (option) {
              handleStatusChange(option as { value: string });
            }
          }}
          value={GREASE_TRAP_STATUS_OPTIONS.find(
            (option) => option.value === status,
          )}
          isSearchable={false}
        />
      </div>
    </div>
  );
};

export default GreaseTrapStatusDropdown;
